// extracted by mini-css-extract-plugin
module.exports = {"outerFlex":"Inclusion_outerFlex__17VIu","heading":"Inclusion_heading__2dPph","listItem":"Inclusion_listItem__3Hm0L","list":"Inclusion_list__3vEUt"};